(function() {
  'use strict';

  function Cards(Sidebar) {
    var service = {};

    service.register = function() {
      var cards = [
        {
          id: 'goals-list-card',
          title: 'Create a new goal event',
          directive: 'goals-list-card',
          options: {
            routes: ['epf.goals.index'],
            paths: ['goals/list', 'goals/list/:filterId']
          }
        },
        {
          id: 'goal-set',
          title: 'All goals within this set',
          directive: 'goalset-card',
          options: {
            routes: [
              'epf.goals.view',
              'epf.goals.work',
              'epf.users.goals-view',
              'epf.users.goals-work'
            ],
            paths: [
              'goals/view/:goalId',
              'goals/work/:goalId',
              'users/view/:user/goals/:goalId',
              'users/work/:user/goals/:goalId'
            ]
          }
        },
        {
          id: 'target-linking-card',
          title: 'Linking status',
          directive: 'target-linking-card',
          options: {
            routes: ['epf.goals.link'],
            paths: [
              'goals/targets/link/:goalId/:targetId/:periodId',
              'users/work/:user/targets/link/:goalId/:targetId'
            ]
          }
        }
      ];

      Sidebar.registerCards(cards);
    };

    return service;
  }

  Cards.$inject = ['SidebarService'];

  angular.module('component.goals')
    .service('GoalsCards', Cards);
})();
